import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import './AlfaTransfersPageContainer.scss';

interface RouteProps extends RouteComponentProps<{}> {
    match: any;
    history: any;
}

export function mapProps() {
    return;
}

export function mapDispatch() {
    return;
}

export class AlfaTransfersPageContainer extends React.Component<RouteProps, {}> {

    render() {
        return (
            <div className='alfa_transfers-container'>
                <b>
                    Условия заказа трансферов:
                </b>
                <br/>
                <br/>
                Здесь вы можете заказать поездку бизнес-класса в аэропорт или из него, а потом компенсировать ее в рамках программы привилегий для премиальных клиентов Банка. За один лимит из программы привилегий вы можете компенсировать одну поездку и получить до 2500 рублей на счёт. Для компенсации оплатить поездку нужно картой Банка.
                <br/>
                <br/>
                Стоимость трансфера рассчитаем после того, как вы оставите заявку.
                <br/>
                <br/>
                Трансферы доступны по всему миру.
                <br/>
                <br/>
                Заказать трансфер можно не позднее чем за 24 часа для поездки по России (не позднее чем за 4 часа для поездки в Москве и Санкт-Петербурге) и не позднее чем за 48 часов для заказа поездки за рубежом.
                <br/>
                <br/>
                Гарантирован только класс автомобиля, марка и модель автомобиля не могут быть гарантированы.
                <br/>
                <br/>
                <b>
                    Как получить лимиты на трансферы в Банке?
                </b>
                <br/>
                <br/>
                Всё просто: чем больше вы тратите и храните денег на ваших счетах в Банке, тем больше у вас трансферов:
                <li>от 3 млн ₽  на счетах или от 2 млн ₽ на счетах + покупки от 200 000 ₽ в месяц: 2 поездки в год;</li>
                <li>от 6 млн ₽ на счетах: 12 поездок в год (не более 2 в месяц);</li>
                <li>от 12 млн ₽ на счетах: 15 поездок в год (не более 3 в месяц).</li>
                <br/>
                <br/>
                Проверить свои лимиты можно в мобильном приложении Банка: Профиль&nbsp;→&nbsp;Уровни привилегий.
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/AlfaTransfers/AlfaTransfersPageContainer.tsx